import React from "react";
import ChatWindow from "../components/Messaging/ChatWindow";

const MessagingPage = () => {
  const initialMessages = [
    { content: "Hello!", sender: "Alice", isMine: false },
    { content: "Hi Alice, how are you?", sender: "You", isMine: true },
  ];

  const handleSendMessage = (newMessage) => {
    console.log("Message sent:", newMessage); // Tu peux connecter ça au backend
  };

  return (
    <div className="messaging-page">
      <h1 className="text-xl font-bold mb-4">Messaging</h1>
      <ChatWindow messages={initialMessages} onSendMessage={handleSendMessage} />
    </div>
  );
};

export default MessagingPage;